import React from 'react';
import { CurrentInterviewsViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: CurrentInterviewsViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
